var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","color":_vm.color,"href":"mailto:token@cudos.org?subject=I need help signing in to the CUDOS Token Holder Portal"},domProps:{"textContent":_vm._s('Contact CUDOS')}})}
var staticRenderFns = []

export { render, staticRenderFns }